import type { RegisteredComponent } from "@builder.io/sdk-react";

export const expandableElementBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "ExpandableElement",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "buttonElement",
      friendlyName: "Button Element",
      helperText: "Element for the button",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "content",
      friendlyName: "Content",
      helperText: "Content inside the expandable element",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "isOpen",
      friendlyName: "Is Open",
      helperText: "Whether the expandable element is open by default",
      type: "boolean",
      defaultValue: false,
    },
    { name: "transitionDuration", type: "text", defaultValue: "0ms" },
    {
      name: "onToggle",
      type: "javascript",
      localized: false,
      helperText:
        "Callback function. When provided, the component becomes controlled and `isOpen` is used as the source of truth.",
    },
  ],
};
